import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import { __GapColors } from '../../../../../../common/Dictionaries';
import './style.css';
import { useRef } from 'react';

function Chart(props) {
  const { t } = useTranslation();

  const inputParam_ComponentData = props.inputParam_ComponentData !== null && props.inputParam_ComponentData !== undefined && props.inputParam_ComponentData !== "" ? props.inputParam_ComponentData : null;
  const inputParam_SetterDataserieValueChartSelected = props.inputParam_SetterDataserieValueChartSelected !== null && props.inputParam_SetterDataserieValueChartSelected !== undefined && props.inputParam_SetterDataserieValueChartSelected !== "" ? props.inputParam_SetterDataserieValueChartSelected : null;

  const inputParam_Height = props.inputParam_Height !== null && props.inputParam_Height !== undefined ? props.inputParam_Height : null;
  const inputParam_Title = props.inputParam_Title !== null && props.inputParam_Title !== undefined ? props.inputParam_Title : null;
  const inputParam_SubTitle = props.inputParam_SubTitle !== null && props.inputParam_SubTitle !== undefined ? props.inputParam_SubTitle : null;
  const inputParam_CircleColor = props.inputParam_CircleColor !== null && props.inputParam_CircleColor !== undefined ? props.inputParam_CircleColor : null;
  
  const onColumnWithGapClick = (dataPoint) => {
    setTimeout(() => {
      inputParam_SetterDataserieValueChartSelected && inputParam_SetterDataserieValueChartSelected(dataPoint)
    }, 10);
  }

  const maxValue = Math.max(...inputParam_ComponentData.map(d => d.displayValue));
  const minValue = maxValue * 0.025;

  const listSeriesX = inputParam_ComponentData ? [
    {
      name: t("data-lang-lbl-field-valueReal"),
      data: inputParam_ComponentData.map(({ displayValue, gapResult, serieTimeStr, ...item }) => {
        return {
          ...item,
          x: serieTimeStr.toString(),
          y: (displayValue === 0 ? minValue : displayValue),
          original: displayValue,
          isZero: displayValue === 0,
          gapResult: gapResult
        }
      }),
      type: "column",
    },
    {
      name: t("data-lang-lbl-field-valueGoal"),
      data: inputParam_ComponentData.map(({ valueGoal, gapResult, serieTimeStr, ...item }) => {
        return {
          ...item,
          x: serieTimeStr.toString(),
          y: valueGoal,
          gapResult: gapResult
        }
      }),
      type: "line",
      color: '#FF8000'
    },
  ] : [];

  const listSerieTimeY = inputParam_ComponentData ? inputParam_ComponentData.map(({ serieTimeStr }) => serieTimeStr) : []

  const annotations = inputParam_ComponentData.filter(x => x.colorGap !== null).map(x => ({
        x: x.serieTimeStr,
        y: x.displayValue,
        marker: {
          size: 8,
          fillColor: __GapColors.find(z => z.key === x.colorGap).text,
          strokeColor: '#fff',
          radius: 12,
          cssClass: ('arrow-icon'),
        },
        label: {
          borderColor: '#AEBCD9',
          borderWidth: 1,
          borderRadius: 1,
        },
  }));

  const listSerieNames = 
  {
    axisTicks: {
      show: true,
    },
    axisBorder: {
      show: true,
      color: '#1F7BE8'
    },
    labels: {
      style: {
        colors: '#1F7BE8',
      }
    },
    tooltip: {
      enabled: true
    },
    title: {
      text: t("data-lang-lbl-field-valueReal"),
      style: {
        color: '#1F7BE8',
      }
    }
  };

  const chartRef = useRef(null)

  useEffect(() => {
    const chart = chartRef.current.chart;

    chart.toggleDataPointSelection(0, inputParam_ComponentData.findIndex(item => item.gapResult === true));
    chart.updateOptions({
      legend: {
        markers: {
          fillColors: ['#1F7BE8', '#FF8000', '#000099'],
        },
      },
    });
  }, []);

  return (
          <>
            {
              inputParam_ComponentData ?
              <>
                <Col>
                  {
                    (inputParam_Title || inputParam_SubTitle) &&
                    <Row>
                      {
                        inputParam_Title &&
                        <>
                          <Col className='col-auto me-auto'>
                            {
                              inputParam_CircleColor &&
                              <div className="rounded-circle border" style={{width: "25px", height: "25px", backgroundColor: __GapColors.find(x => x.key === inputParam_CircleColor).text}}></div>
                            }
                          </Col>
                          <Col>
                            <>
                              {
                                inputParam_Title
                              }
                              {
                                inputParam_SubTitle && inputParam_SubTitle
                              }
                            </>
                          </Col>
                        </>
                      }
                    </Row>
                  }
                  <Row>
                  <ReactApexChart 
                    ref={chartRef}
                    type="line"
                    series={listSeriesX}
                    options={
                      {
                        chart: {
                          height: 350,
                          type: 'line',
                          events: {
                            dataPointSelection: (event, chartContext, config) => { 
                              let dataPoint = listSeriesX[config.seriesIndex].data[config.dataPointIndex]; 
                              onColumnWithGapClick(dataPoint)                                
                            }
                          }
                        },
                        stroke: {
                          width: [0, 4]
                        },
                        plotOptions: {
                          bar: {
                            columnWidth: '50%'
                          }
                        },
                        dataLabels: {
                          enabled: false,
                        },
                        labels: listSerieTimeY,
                        xaxis: {
                          categories: listSerieTimeY
                        },
                        yaxis: listSerieNames,
                        annotations: {
                          points: annotations,
                        },
                        tooltip: {
                          shared: true,
                          intersect: false,
                          y: {
                            formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
                              if (seriesIndex === 0) {
                                return `${t("data-lang-lbl-field-valueReal")}: ${listSeriesX[0].data[dataPointIndex].original}`;
                              } else {
                                return `${t("data-lang-lbl-field-valueGoal")}: ${listSeriesX[1].data[dataPointIndex].y}`;
                              }
                            }
                          },
                          fixed: {
                            enabled: true,
                            position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
                            offsetY: 30,
                            offsetX: 60
                          },
                        },
                        legend: {
                          horizontalAlign: 'center',
                          offsetX: 40
                        }
                      }
                    }
                    height={inputParam_Height !== null ? inputParam_Height : 350}
                  />
                  </Row>
                </Col>
              </> : <NoDataLayer display={ true } />
            } 
          </>
  );
}

export default Chart;